<template>
    <div class="pending-reseller">
        <ResellerBlock
            :reseller="reseller.company_name"
            :id="reseller.id"
            :options="true"
            :clientsCount="reseller.clients.length"
            :isPending="true"
            @deleteReseller="$emit('deleteReseller')"
            @deactivateReseller="$emit('deactivateReseller')"
        />

        <div class="pending-reseller--information">
            <div class="pending-reseller--information--block">
                <h5>{{ t('general.invitation.invited') }}</h5>
                <p>{{ t('general.invitation.send_to') }} {{ reseller.email }}</p>

                <div class="button-group">
                    <button class="button button--rounded" @click="reSendMail(reseller.id)">{{ t('general.resend_invitation') }}</button>
                    <button class="button button--rounded button--ghost" @click="resendOtherEmail">{{ t('general.resend_invitation.other_email') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swal from 'sweetalert';
import { post } from '@/helpers/http';
import handleError from '@/helpers/error';
import { validEmail } from '@/helpers/validator';

import ResellerBlock from './ResellerBlock';

export default {
    name: 'ResellerInformation',

    props: ['reseller'],

    methods: {
        reSendMail(id) {
            post({
                url: `${this.$API_URL}/api/admin/resellers/invite/${id}/resend`,
                data: {
                    reseller_id: this.reseller.id,
                    email: this.reseller.email,
                },
            })
                .then(() => {
                    swal({
                        title: this.$translate.text('alert.title.invitation.resend'),
                        text: this.$translate.text('general.invitation.send_to') + this.reseller.email,
                        buttons: {
                            confirm: {
                                text: this.$translate.text('general.ok'),
                            },
                        },
                    });
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resendOtherEmail() {
            const translationString = this.$translate.text('general.resend_invitation.explanation');
            swal({
                title: this.$translate.text('general.resend_invitation'),
                text: translationString.replace('%x', this.reseller.email),
                content: {
                    element: 'input',
                    attributes: {
                        type: 'email',
                    },
                },
                buttons: {
                    cancel: this.$translate.text('general.cancel'),
                    confirm: {
                        text: this.$translate.text('general.resend_invitation'),
                    },
                },
                closeOnEsc: false,
            })
                .then(value => {
                    // if user clicked the modal away or the close button
                    if (value === null) return null;

                    // Check if the email filled in is a valid email.
                    if (!validEmail(value)) return false;

                    // its all valid so continue with the value
                    return value;
                })
                .then(email => {
                    // Since it will always go to the next then check what previous result was.
                    if (email != null) {
                        // check if the value is correct from the previous then
                        if (email === false) {
                            swal({
                                title: this.$translate.text('alert.whoops'),
                                text: this.$translate.text('alert.whoops.message.invalid_email'),
                            })
                                .then(() => {
                                    this.resendOtherEmail();
                                });
                        } else {
                            // Make the call
                            post({
                                url: `${this.$API_URL}/api/admin/resellers/invite/${this.reseller.id}/resend`,
                                data: {
                                    reseller_id: this.reseller.id,
                                    email,
                                },
                            })
                                .then(() => {
                                    swal({
                                        title: this.$translate.text('alert.title.invitation.send'),
                                        text: this.$translate.text('general.invitation.send_to') + email,
                                    });
                                })
                                .catch((error) => {
                                    handleError({
                                        error,
                                        message: this.$translate.text('alert.whoops'),
                                    });
                                });
                        }
                    }
                });
        },
    },

    components: {
        ResellerBlock,
    },
};
</script>

<style lang="scss" scoped>
.pending-reseller {
    margin-bottom: 0px;
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-gap: 8px;
    margin-bottom: 32px;
    margin-top: 16px;

    &--information {
        display: grid;
        grid-template-columns: 1fr;
        grid-gap: 8px;
        background-color: white;
        border-radius: 4px;
        padding: 16px;

        @media(min-width: 992px) {
            grid-template-columns: 3fr 1fr;
        }

        @media(min-width: 1200px) {
            grid-template-columns: 3fr 1fr;
        }

        h5, p {
            margin-bottom: 8px;
        }
    }
}
</style>
